import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Empty, Image,Modal, Skeleton, Space, TablePaginationConfig, Tooltip } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import dayjs from 'dayjs';
import { AddNotificationTemplateModal } from 'features/notification/components/modal/AddNotificationTemplateModal';
import { NotificationTemplateFilterFormValuesPaginated } from 'features/notification/components/type';
import { useDeleteNotificationTemplate } from 'features/notification/use-cases/delete-template';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Notificationtype } from 'types/notification-type';
type NotificationTableProps = {
    isUsersListLoading: boolean;
    typeReportList: Notificationtype[];
    itemsCount: number;
    tableParams: NotificationTemplateFilterFormValuesPaginated;
    refetch: any
    updateParams: Dispatch<SetStateAction<NotificationTemplateFilterFormValuesPaginated>>;
};

export const NotificationTemplateTable = ({
    typeReportList,
    isUsersListLoading,
    itemsCount,
    tableParams,
    refetch,
    updateParams,
}: NotificationTableProps) => {
    const { t } = useTranslation();
    const [showAddItemModal, setShowAddItemModal] = useState<boolean>(false);

    const [Data, setData] = useState<any>(/* Your initial data array */);
    const { confirm } = Modal;
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<Notificationtype> | SorterResult<Notificationtype>[],
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };

    const [templateEditData, setTemplateEditData] = useState<any>(undefined);
    const handleOpenModal = (record: any) => {
        setShowAddItemModal(true)
        document.body.style.overflow = 'hidden';
        setTemplateEditData(record)
    }

    const { mutate: mutateUpdateItem } =
        useDeleteNotificationTemplate();

    const handleDelete = async (id: any) => {
        try {
            // Simulate the 
            // loading state

            mutateUpdateItem({
                NotificationTemplateId: id,
            });

            const newData = Data.filter((item: any) => item.id !== id);
            setData(newData);
        } catch (error) {
            console.error("error")
        }
    };

    const showDeleteConfirm = (record: any) => {
        confirm({
            title: 'Are you sure you want to delete this Template?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleDelete(record.Id);
            },
        } as any);
    };
    const handleCloseModal = () => {
        setShowAddItemModal(false)
        document.body.style.overflow = 'visible';
    }

    return (
        <StyledTableWrapper>
            {/* <div className={`cstmrightmdl ${showAddItemModal && "show"}`}>
                <EditNotificationModal onClose={handleCloseModal} refetch={refetch} showAddItemModal={showAddItemModal} editData={notificationTypeEdit} />
            </div>  */}
            <div className={`cstmrightmdl ${showAddItemModal && "show"}`}>
                <AddNotificationTemplateModal onClose={handleCloseModal} refetch={refetch} showAddItemModal={showAddItemModal} templateEditData={templateEditData} />
            </div>

            <StyledTableHeader>
                <RecordCountBadge
                    text={t('vendingMachine.foundRecord')}
                    count={isUsersListLoading ? 0 : itemsCount || 0}
                />
            </StyledTableHeader>
            <Table<Notificationtype>
                // loading={isUsersListLoading}
                // dataSource={typeReportList}
                className="cstltblwthldr"
                locale={{
                    emptyText: isUsersListLoading ? <Skeleton active={true} /> : <Empty />
                }}
                loading={isUsersListLoading && { indicator: <div><TableLoader /></div> }}
                dataSource={isUsersListLoading ? [] : typeReportList}
                rowKey='id'
                onChange={handleTableChange}
                pagination={{
                    current: tableParams.page,
                    defaultPageSize: tableParams.size,
                    total: itemsCount,
                }}
            >
                <Column<Notificationtype>
                    title={'Template Name '}
                    dataIndex={'TemplateName'}
                />

                <Column<Notificationtype>
                    title={' Notification Type '}
                    dataIndex={'AnnouncementType'}
                />
                <Column<Notificationtype>
                    title={'Title '}
                    dataIndex={'Title'}
                />
                <Column<Notificationtype>
                    title={'Message '}
                    dataIndex={'ContentEn'}
                    render={(value: string) => (
                        <div dangerouslySetInnerHTML={{ __html: value }} />
                    )}
                />
                <Column<Notificationtype>
                    title="Image English"
                    dataIndex="ImageUrl"
                    render={(value?: string) =>
                        value ? (
                            <Image
                                src={value}
                                alt="image"
                                width={60}
                                height={60}
                                style={{ objectFit: "cover", borderRadius: 6 }}
                            />
                        ) : (
                            "-"
                        )
                    }
                />
                <Column<Notificationtype>
                    title="Image Arabic"
                    dataIndex="ArabicImage_Url"
                    render={(value?: string) =>
                        value ? (
                            <Image
                                src={value}
                                alt="image"
                                width={60}
                                height={60}
                                style={{ objectFit: "cover", borderRadius: 6 }}
                            />
                        ) : (
                            "-"
                        )
                    }
                />
                <Column<Notificationtype>
                    title={'CreatedOn '}
                    dataIndex={'CreatedOn'}
                    render={(value: string) => dayjs(value).format("DD/MM/YYYY")}
                />

                <Column
                    title="Action"
                    dataIndex="email_address"
                    render={(_, record: any) => (
                        <Space>
                            <Tooltip title="Edit">
                                <Button
                                    shape="circle"
                                    onClick={() => handleOpenModal(record)}
                                    icon={<EditOutlined />}
                                />
                            </Tooltip>

                            <Tooltip title="Delete">
                                <Button
                                    shape="circle"
                                    onClick={() => showDeleteConfirm(record)}
                                    icon={<DeleteOutlined />}
                                />
                            </Tooltip>
                        </Space>
                    )}
                />
            </Table>
        </StyledTableWrapper>
    );
};
